import { SHARED_ROUTES } from '@aibees/shared/constants';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Styled from './styles';

export const UpgradePlanButton = memo(() => {
  const { data } = useCurrentSubscriptionApi();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isPricingPage = pathname === SHARED_ROUTES.priceAndPlan;

  const goToPricingPage = () => {
    navigate(SHARED_ROUTES.priceAndPlan);
  };

  if (data?.current?.plan?.trial || isPricingPage) return null;
  return (
    <Styled.UpdradeLink
      variant="outlined"
      size="small"
      onClick={goToPricingPage}
    >
      <span role="img" aria-label="rocket">
        🚀
      </span>{' '}
      Upgrade
    </Styled.UpdradeLink>
  );
});

UpgradePlanButton.displayName = 'UpgradePlanButton';
